var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.adminPlusVersion)?_c('UserMenuAdminPlus',_vm._g(_vm._b({},'UserMenuAdminPlus',_vm.$props,false),_vm.$listeners)):_c('UserMenuLegacy',_vm._g(_vm._b({},'UserMenuLegacy',_vm.$props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }